/* UpLift storefront behaviour — lightweight, dependency-free.
   Everything degrades gracefully: no JS = static, fully readable page. */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var body = doc.body;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var motionOff = function () { return body.classList.contains('up-no-motion') || reduced.matches; };
  var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };
  var mobileMotionOff = function () { return !isDesktop() && body.classList.contains('up-no-motion-mobile'); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var $ = function (sel, ctx) { return (ctx || doc).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); };

  /* ------------------------------------------------------------------ reveal */
  function initReveal(scope) {
    var els = $$('[data-up-reveal], .up-lines, .up-zoom-in', scope || doc);
    if (!els.length) return;
    if (motionOff() || mobileMotionOff() || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------ hero */
  function initHero() {
    $$('[data-up-hero]').forEach(function (hero) {
      if (hero.dataset.upHeroReady) return;
      hero.dataset.upHeroReady = '1';
      var words = $$('.up-hero__word', hero);
      // benefit words fade in one after another once the headline has revealed
      if (motionOff() || (!isDesktop() && mobileMotionOff())) words.forEach(function (w) { w.classList.add('is-on'); });
      else words.forEach(function (w, i) { setTimeout(function () { w.classList.add('is-on'); }, 1100 + i * 260); });
      // light scroll parallax (desktop only): layers drift down a little, copy lifts and fades
      var parallax = isDesktop() && !motionOff();
      var ticking = false;
      var update = function () {
        ticking = false;
        if (!parallax) { hero.style.setProperty('--p', '0'); return; }
        var h = hero.offsetHeight || 1;
        var p = clamp(window.scrollY / h, 0, 1);
        hero.style.setProperty('--p', p.toFixed(4));
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { parallax = isDesktop() && !motionOff(); onScroll(); });
      update();
    });
  }

  /* ------------------------------------------------------------------ story */
  function initStory() {
    $$('[data-up-story]').forEach(function (story) {
      var steps = $$('.up-story__step', story);
      var media = $('.up-story__media', story);
      var bars = $$('.up-story__progress i', story);
      var alts = $$('.up-story__alt', story);
      if (!steps.length || !media) return;
      var activate = function (idx) {
        steps.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        bars.forEach(function (b, i) { b.classList.toggle('is-on', i <= idx); });
        media.style.setProperty('--sp', steps.length > 1 ? (idx / (steps.length - 1)).toFixed(3) : '0');
        var hasAlt = false;
        alts.forEach(function (a) { var m = /up-story__alt--(\d+)/.exec(a.className); var on = m && Number(m[1]) === idx; a.classList.toggle('is-on', on); if (on) hasAlt = true; });
        media.classList.toggle('has-alt', hasAlt);
      };
      if (!('IntersectionObserver' in window)) { activate(0); steps.forEach(function (s) { s.classList.add('is-active'); }); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) activate(steps.indexOf(e.target)); });
      }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
      steps.forEach(function (s) { io.observe(s); });
      activate(0);
    });
  }

  /* ------------------------------------------------------------------ parallax */
  function initParallax() {
    var els = $$('[data-up-parallax]');
    if (!els.length || motionOff()) return;
    var ticking = false;
    var update = function () {
      ticking = false;
      if (!isDesktop()) { els.forEach(function (el) { el.style.removeProperty('--py'); }); return; }
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var center = r.top + r.height / 2 - vh / 2;
        var strength = Number(el.dataset.upParallax) || 30;
        el.style.setProperty('--py', (center / vh * strength).toFixed(2));
      });
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ------------------------------------------------------------------ announcement */
  function initAnnouncement() {
    $$('[data-up-announce]').forEach(function (bar) {
      var items = $$('.up-announce__item', bar);
      if (items.length < 2) { bar.classList.add('up-announce--single'); items.forEach(function (i) { i.classList.add('is-active'); }); return; }
      var idx = 0;
      items[0].classList.add('is-active');
      setInterval(function () {
        items[idx].classList.remove('is-active');
        idx = (idx + 1) % items.length;
        items[idx].classList.add('is-active');
      }, Number(bar.dataset.interval) || 4500);
    });
  }

  /* ------------------------------------------------------------------ header */
  function initHeader() {
    var wrap = $('[data-up-header]');
    if (!wrap) return;
    var last = window.scrollY;
    var ticking = false;
    var update = function () {
      ticking = false;
      var y = window.scrollY;
      wrap.classList.toggle('is-stuck', y > 4);
      // Keep the Uplift header visible at all times while scrolling.
      wrap.classList.remove('is-hidden');
      last = y;
      var h = wrap.offsetHeight;
      if (h) root.style.setProperty('--up-header-total', h + 'px');
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    var ann = $('.up-announce');
    root.style.setProperty('--up-announce-h', (ann ? ann.offsetHeight : 0) + 'px');

    // drawer
    var drawer = $('#up-menu-drawer');
    $$('[data-up-menu-open]').forEach(function (b) { b.addEventListener('click', function () { if (drawer && drawer.showModal) drawer.showModal(); }); });
    $$('[data-up-menu-close]').forEach(function (b) { b.addEventListener('click', function () { drawer && drawer.close(); }); });
    if (drawer) drawer.addEventListener('click', function (e) { if (e.target === drawer) drawer.close(); });

    // nested "Shop" menu — desktop: click toggles the small dropdown (hover is CSS), closes on outside click / Esc.
    var subs = $$('[data-up-nav-sub]');
    var closeSubs = function (except) {
      subs.forEach(function (li) {
        if (li === except) return;
        li.classList.remove('is-open');
        var t = li.querySelector('[data-up-nav-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
      });
    };
    subs.forEach(function (li) {
      var toggle = li.querySelector('[data-up-nav-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function (e) {
        // first click/tap opens the dropdown; a second click follows the link
        if (!li.classList.contains('is-open')) {
          e.preventDefault();
          closeSubs(li);
          li.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
      li.addEventListener('mouseleave', function () { li.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); });
    });
    doc.addEventListener('click', function (e) { if (!e.target.closest('[data-up-nav-sub]')) closeSubs(); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSubs(); });
    // mobile drawer accordion
    $$('[data-up-drawer-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        var panel = doc.getElementById(btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.hidden = open;
      });
    });

    // cart
    var counts = $$('[data-up-cart-count]');
    var setCount = function (n) {
      counts.forEach(function (c) {
        var prev = Number(c.dataset.count || 0);
        c.dataset.count = String(n);
        c.textContent = n > 99 ? '99+' : String(n);
        if (n !== prev) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
      });
    };
    var refreshCount = function () {
      fetch((window.Theme && Theme.routes && Theme.routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count || 0); }).catch(function () {});
    };
    doc.addEventListener('shopify:cart:lines-update', function () { setTimeout(refreshCount, 250); });
    doc.addEventListener('cart:update', function () { setTimeout(refreshCount, 250); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
    window.upRefreshCart = refreshCount;

    // The DropMagic sidecart (dm-cart.js) owns the cart drawer when it is present:
    // it intercepts the header cart link and opens itself on every add-to-cart.
    // Make sure the theme's own drawer never opens on top of it.
    var dmCart = function () { return $('dm-sheet[data-sheet-open-on="cart"]'); };
    if (dmCart()) {
      $$('cart-drawer-component[auto-open]').forEach(function (c) { c.removeAttribute('auto-open'); });
      // Horizon persists open drawers in sessionStorage and restores them on the
      // next page (as a squeezed sidebar on wide screens). If the theme drawer was
      // left open behind the DropMagic sheet, close it and stop persisting it.
      var hd = $('theme-drawer#cart-drawer');
      if (hd) {
        hd.setAttribute('no-persist', '');
        var closeHd = function () { if (hd.hasAttribute('open') && typeof hd.close === 'function') hd.close(); };
        if (window.customElements && customElements.whenDefined) customElements.whenDefined('theme-drawer').then(closeHd).catch(function () {});
        else closeHd();
      }
      try {
        var ids = (sessionStorage.getItem('theme-drawer-open') || '').split(',').filter(function (x) { return x && x !== 'cart-drawer'; });
        if (ids.length) sessionStorage.setItem('theme-drawer-open', ids.join(',')); else sessionStorage.removeItem('theme-drawer-open');
      } catch (err) {}
    }
    $$('[data-up-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (dmCart()) { e.preventDefault(); return; }
        var actions = window.Shopify && window.Shopify.actions;
        var drawerEl = $('theme-drawer#cart-drawer');
        if (drawerEl && actions && actions.openCart) { e.preventDefault(); actions.openCart(); }
        else if (drawerEl && typeof drawerEl.open === 'function') { e.preventDefault(); drawerEl.open(); }
      });
    });
  }

  /* ------------------------------------------------------------------ accordion */
  function initAccordion(scope) {
    $$('.up-acc__btn', scope || doc).forEach(function (btn) {
      if (btn.dataset.upBound) return;
      btn.dataset.upBound = '1';
      var panel = doc.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      panel.classList.toggle('is-open', open);
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        var group = btn.closest('[data-up-single]');
        if (group && !isOpen) {
          $$('.up-acc__btn[aria-expanded="true"]', group).forEach(function (other) {
            other.setAttribute('aria-expanded', 'false');
            var p = doc.getElementById(other.getAttribute('aria-controls'));
            p && p.classList.remove('is-open');
          });
        }
        btn.setAttribute('aria-expanded', String(!isOpen));
        panel.classList.toggle('is-open', !isOpen);
      });
    });
  }

  /* ------------------------------------------------------------------ modals */
  function initModals() {
    $$('[data-up-modal-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var m = $(b.dataset.upModalOpen);
        if (m && m.showModal) { e.preventDefault(); m.showModal(); }
      });
    });
    $$('.up-modal').forEach(function (m) {
      m.addEventListener('click', function (e) { if (e.target === m) m.close(); });
      $$('[data-up-modal-close]', m).forEach(function (b) { b.addEventListener('click', function () { m.close(); }); });
    });
  }

  /* ------------------------------------------------------------------ size guide */
  // Places the "Size Guide" link next to whichever size selector the page
  // uses (UpLift product section, DropMagic option picker or DropMagic
  // bundle units) and opens the dialog rendered by snippets/uplift-size-guide.
  function initSizeGuide() {
    var dialog = $('#up-size-guide');
    var tpl = $('#up-size-guide-trigger');
    if (!dialog || !tpl || !tpl.content || !dialog.showModal) return;
    var make = function () {
      var el = tpl.content.firstElementChild.cloneNode(true);
      el.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (!dialog.open) dialog.showModal();
      });
      return el;
    };
    var has = function (scope) { return !!(scope && scope.querySelector('[data-up-sizeguide-open]')); };
    var placed = false;

    // 1) UpLift product section — size option label row
    $$('.up-opt__label').forEach(function (lab) {
      if (has(lab) || !/size/i.test(lab.textContent)) return;
      lab.appendChild(make()); placed = true;
    });

    // 2) DropMagic option picker — "Size: X" label row sits directly above it
    $$('dm-option-picker[data-option-name]').forEach(function (picker) {
      if (!/size/i.test(picker.getAttribute('data-option-name') || '')) return;
      var lab = picker.previousElementSibling;
      if (lab && /size/i.test(lab.textContent || '') && lab.getBoundingClientRect().height < 60) {
        if (has(lab)) return;
        lab.appendChild(make()); placed = true;
      } else if (!(picker.previousElementSibling && picker.previousElementSibling.classList.contains('up-sizeguide__row'))) {
        var row = doc.createElement('div'); row.className = 'up-sizeguide__row'; row.appendChild(make());
        picker.parentNode.insertBefore(row, picker); placed = true;
      }
    });

    // 3) DropMagic bundle — per-unit size <select>s; link sits under the bundle cards
    $$('dm-bundle').forEach(function (bundle) {
      if (!bundle.querySelector('select[data-variant-option-name*="ize"], select[aria-label*="ize"]')) return;
      var next = bundle.nextElementSibling;
      if (next && next.classList.contains('up-sizeguide__row')) return;
      var row = doc.createElement('div'); row.className = 'up-sizeguide__row'; row.appendChild(make());
      bundle.insertAdjacentElement('afterend', row); placed = true;
    });

    if (!dialog.dataset.upSgBound) {
      dialog.dataset.upSgBound = '1';
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      $$('[data-up-modal-close]', dialog).forEach(function (b) { b.addEventListener('click', function () { dialog.close(); }); });
    }
    return placed;
  }

  /* ------------------------------------------------------------------ money */
  function formatMoney(cents, format) {
    var f = format || (window.Theme && Theme.moneyFormat) || '${{amount}}';
    var value = '';
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(f);
    var key = m ? m[1] : 'amount';
    var n = (Number(cents) || 0) / 100;
    var withDelims = function (num, precision, thousands, decimal) {
      var parts = num.toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    switch (key) {
      case 'amount': value = withDelims(n, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelims(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelims(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(n, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(n, 2, "'", '.'); break;
      default: value = withDelims(n, 2, ',', '.');
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ------------------------------------------------------------------ product */
  function initProduct() {
    $$('[data-up-product]').forEach(function (el) {
      var dataEl = $('[data-up-variants]', el);
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var form = $('form[data-up-form]', el);
      var idInput = form ? $('input[name="id"]', form) : null;
      var qtyInput = form ? $('input[name="quantity"]', form) : null;
      var optionGroups = $$('[data-up-option]', el);
      var priceEl = $('[data-up-price]', el);
      var compareEl = $('[data-up-compare]', el);
      var saveEl = $('[data-up-save]', el);
      var atc = $('[data-up-atc]', el);
      var atcLabel = atc ? $('.up-btn__label', atc) : null;
      var errorEl = $('[data-up-error]', el);
      var sticky = $('[data-up-sticky]', el);
      var stickyTitle = sticky ? $('[data-up-sticky-title]', sticky) : null;
      var stickyPrice = sticky ? $('[data-up-sticky-price]', sticky) : null;
      var stickyImg = sticky ? $('img', sticky) : null;
      var moneyFormat = el.dataset.moneyFormat;
      var labels = { add: el.dataset.labelAdd || 'Add to cart', soldOut: el.dataset.labelSoldout || 'Sold out', unavailable: el.dataset.labelUnavailable || 'Unavailable' };
      var current = variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || variants[0];

      // Existing DropMagic quantity-break offers, presented in the premium Uplift UI.
      var bundleEl = $('[data-up-bundle]', el);
      var bundleTiers = bundleEl ? $('[data-up-bundle-tier]', bundleEl) : [];
      var dynamicEl = $('.up-buy__dynamic', el);
      var selectedBundle = null;
      var renderBundlePrices = function (v) {
        if (!v || !bundleTiers.length) return;
        bundleTiers.forEach(function (tier) {
          var qty = Number(tier.dataset.qty || 1);
          var discount = Number(tier.dataset.discount || 0);
          var regular = v.price * qty;
          var total = Math.round(regular * (1 - discount / 100));
          var totalEl = $('[data-up-bundle-total]', tier);
          var compare = $('[data-up-bundle-compare]', tier);
          if (totalEl) totalEl.textContent = formatMoney(total, moneyFormat);
          if (compare) {
            compare.textContent = discount > 0 ? formatMoney(regular, moneyFormat) : '';
            compare.hidden = !(discount > 0);
          }
        });
      };
      var selectBundle = function (tier) {
        if (!tier) return;
        bundleTiers.forEach(function (b) {
          var on = b === tier;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', String(on));
        });
        selectedBundle = {
          qty: Number(tier.dataset.qty || 1),
          discount: Number(tier.dataset.discount || 0),
          barId: tier.dataset.barId || ''
        };
        if (qtyInput) qtyInput.value = selectedBundle.qty;
        if (dynamicEl) dynamicEl.hidden = selectedBundle.qty > 1;
        renderBundlePrices(current);
      };
      bundleTiers.forEach(function (tier) {
        tier.addEventListener('click', function () { selectBundle(tier); });
      });
      if (bundleTiers.length) {
        selectBundle(bundleTiers.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0] || bundleTiers[0]);
      }

      // gallery
      var track = $('.up-gallery__track', el);
      var slides = $$('.up-gallery__slide', el);
      var thumbs = $$('.up-gallery__thumb', el);
      var dots = $$('.up-gallery__dots i', el);
      var goTo = function (idx, smooth) {
        if (!track || !slides[idx]) return;
        track.scrollTo({ left: slides[idx].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      };
      var loadSlide = function (i) {
        var s = slides[i]; if (!s) return;
        $$('img[data-up-src]', s).forEach(function (img) {
          img.srcset = img.dataset.upSrcset || ''; img.src = img.dataset.upSrc;
          img.removeAttribute('data-up-src'); img.removeAttribute('data-up-srcset');
          img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
        });
      };
      var markActive = function (idx) {
        loadSlide(idx); loadSlide(idx + 1); loadSlide(idx - 1);
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); if (i === idx && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        var counter = $('[data-up-gallery-idx]', el); if (counter) counter.textContent = idx + 1;
      };
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); markActive(i); }); });
      if (track) {
        var st;
        track.addEventListener('scroll', function () {
          clearTimeout(st);
          st = setTimeout(function () {
            var idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            markActive(clamp(idx, 0, slides.length - 1));
          }, 60);
        }, { passive: true });
      }
      markActive(0);

      var selected = function () {
        return optionGroups.map(function (g) {
          var sel = $('[aria-checked="true"]', g);
          return sel ? sel.dataset.value : null;
        });
      };
      var findVariant = function (vals) {
        return variants.filter(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); })[0];
      };
      var refreshAvailability = function (vals) {
        optionGroups.forEach(function (g, gi) {
          $$('[data-value]', g).forEach(function (btn) {
            var test = vals.slice(); test[gi] = btn.dataset.value;
            var match = variants.filter(function (v) { return v.options.every(function (o, i) { return test[i] === null || o === test[i]; }); });
            var exists = match.length > 0;
            var available = match.some(function (v) { return v.available; });
            btn.classList.toggle('is-unavailable', !exists || !available);
          });
        });
      };
      var render = function (v) {
        current = v;
        if (idInput) idInput.value = v ? v.id : '';
        if (priceEl && v) priceEl.textContent = formatMoney(v.price, moneyFormat);
        if (compareEl) {
          var onSale = v && v.compare_at_price && v.compare_at_price > v.price;
          compareEl.textContent = onSale ? formatMoney(v.compare_at_price, moneyFormat) : '';
          compareEl.hidden = !onSale;
          if (saveEl) { saveEl.hidden = !onSale; if (onSale) saveEl.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
        }
        if (atc) {
          var can = v && v.available;
          atc.disabled = !can;
          if (atcLabel) atcLabel.textContent = !v ? labels.unavailable : (can ? labels.add : labels.soldOut);
        }
        if (v && v.media_index != null && v.media_index >= 0) { goTo(v.media_index); markActive(v.media_index); }
        if (stickyTitle && v) stickyTitle.textContent = v.title;
        if (stickyPrice && v) stickyPrice.textContent = formatMoney(v.price, moneyFormat);
        if (stickyImg && v && v.image) stickyImg.src = v.image;
        renderBundlePrices(v);
        optionGroups.forEach(function (g, gi) {
          var out = $('[data-up-selected]', g);
          if (out && v) out.textContent = v.options[gi];
        });
        if (v && window.history && history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        }
      };
      optionGroups.forEach(function (g, gi) {
        $$('[data-value]', g).forEach(function (btn) {
          btn.addEventListener('click', function () {
            $$('[data-value]', g).forEach(function (b) { b.setAttribute('aria-checked', 'false'); b.classList.remove('is-selected'); });
            btn.setAttribute('aria-checked', 'true'); btn.classList.add('is-selected');
            var vals = selected();
            var v = findVariant(vals);
            if (!v) {
              // pick closest variant sharing this option value
              v = variants.filter(function (x) { return x.options[gi] === btn.dataset.value; })[0];
              if (v) {
                optionGroups.forEach(function (g2, gi2) {
                  $$('[data-value]', g2).forEach(function (b) { var on = b.dataset.value === v.options[gi2]; b.setAttribute('aria-checked', String(on)); b.classList.toggle('is-selected', on); });
                });
                vals = v.options.slice();
              }
            }
            refreshAvailability(vals);
            render(v);
          });
        });
      });
      refreshAvailability(selected());
      render(current);

      // quantity
      $$('[data-up-qty]', el).forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qtyInput) return;
          var n = clamp((Number(qtyInput.value) || 1) + Number(b.dataset.upQty), 1, 99);
          qtyInput.value = n;
        });
      });

      // add to cart
      var busy = false;
      var showError = function (msg) { if (!errorEl) return; errorEl.textContent = msg; errorEl.classList.add('is-visible'); setTimeout(function () { errorEl.classList.remove('is-visible'); }, 6000); };
      var addToCart = function () {
        if (busy || !current || !current.available) return;
        var qty = selectedBundle ? selectedBundle.qty : (qtyInput ? (Number(qtyInput.value) || 1) : 1);
        var useBundleDiscount = !!(selectedBundle && selectedBundle.qty > 1 && selectedBundle.barId);
        var actions = window.Shopify && window.Shopify.actions;
        var buttons = [atc, sticky && $('button', sticky)].filter(Boolean);
        busy = true;
        buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
        var done = function (ok) {
          busy = false;
          buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
          if (ok) {
            atc && atc.classList.add('is-added');
            setTimeout(function () { atc && atc.classList.remove('is-added'); }, 2200);
            window.upRefreshCart && window.upRefreshCart();
          }
        };
        // When the DropMagic sidecart is present, add via /cart/add.js so its fetch
        // intercept can render the new line and open its own drawer.
        var dmSheet = $('dm-sheet[data-sheet-open-on="cart"]');
        if (actions && actions.updateCart && !useBundleDiscount && !dmSheet) {
          actions.updateCart({ lines: [{ merchandiseId: String(current.id), quantity: qty }] }, { event: { context: 'product' } })
            .then(function (res) {
              if (res && res.userErrors && res.userErrors.length) { showError(res.userErrors[0].message); done(false); return; }
              done(true);
              if (actions.openCart) actions.openCart();
            })
            .catch(function (err) { showError((err && err.message) || 'Something went wrong. Please try again.'); done(false); });
          return;
        }
        var fd = new FormData();
        fd.append('id', current.id); fd.append('quantity', qty);
        if (useBundleDiscount) {
          fd.append('properties[_bundle_type]', 'quantity-breaks');
          fd.append('properties[_bar_id]', selectedBundle.barId);
        }
        fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { showError(res.message || res.description || 'Could not add to cart.'); done(false); return; }
            done(true);
            if (dmSheet) return; // dm-cart.js has already refreshed + opened the DropMagic drawer
            var drawerEl = $('theme-drawer#cart-drawer');
            if (drawerEl && typeof drawerEl.open === 'function') { doc.dispatchEvent(new CustomEvent('cart:update')); drawerEl.open(); }
            else window.location.href = '/cart';
          })
          .catch(function () { showError('Network error. Please try again.'); done(false); });
      };
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
      if (sticky) {
        var sb = $('button', sticky);
        sb && sb.addEventListener('click', function () { addToCart(); });
        var row = $('[data-up-atc-row]', el);
        if (row && 'IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (en) {
            var e = en[0];
            sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
          }, { threshold: 0 });
          io.observe(row);
        }
      }
    });
  }

  /* ------------------------------------------------------------------ cart drawer checkout guard */
  // The DropMagic cart drawer's CHECKOUT is a plain <a href="/checkout">, so the
  // browser navigates natively. Belt-and-braces: if any other script (app embed,
  // pixel, theme handler) cancels that click, still send the customer to the
  // normal Shopify checkout for the current cart. Never runs inside the theme
  // editor, where Shopify intentionally blocks checkout navigation.
  function initCartCheckoutGuard() {
    doc.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var a = t.closest('dm-sheet[data-sheet-open-on="cart"] a[href^="/checkout"]');
      if (!a || (window.Shopify && window.Shopify.designMode)) return;
      if (e.button && e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (e.defaultPrevented) window.location.assign(a.getAttribute('href'));
    });
  }

  /* ------------------------------------------------------------------ boot */
  function boot() {
    initReveal();
    initHero();
    initStory();
    initParallax();
    initAnnouncement();
    initHeader();
    initAccordion();
    initModals();
    initProduct();
    initCartCheckoutGuard();
    initSizeGuide();
    // DropMagic hydrates some blocks after load — retry placement once.
    setTimeout(initSizeGuide, 900);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor: re-run on section load/select
  doc.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target); initAccordion(e.target); initHero(); initStory(); initAnnouncement(); initProduct(); initModals(); initSizeGuide();
    $$('[data-up-reveal], .up-lines, .up-zoom-in', e.target).forEach(function (el) { el.classList.add('is-in'); });
  });
  doc.addEventListener('shopify:block:select', function (e) {
    var step = e.target.closest ? e.target.closest('.up-story__step') : null;
    if (step) step.scrollIntoView({ block: 'center', behavior: 'smooth' });
    var acc = e.target.querySelector ? e.target.querySelector('.up-acc__btn') : null;
    if (acc && acc.getAttribute('aria-expanded') !== 'true') acc.click();
  });
})();
